
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as testdMy7DXSAquBh6Sk9FPcs4WiNSrwg0P88HVzB8wB_45YwUMeta } from "/build/pages/test.vue?macro=true";
import { default as aboutPxBLKIZlPRBLW8MmpGINvd4MmfZ0Ma8OD7o5tWt6idwMeta } from "/build/pages/about.vue?macro=true";
import { default as indexfaSkdcsHLeb812gzXZAgK_hEZEnndCv3Vs4JNO6v_aQMeta } from "/build/pages/index.vue?macro=true";
import { default as termsymdNmWGbNEE_nG28HGtaieq7FHDak2zVL0PWeMaLkyQMeta } from "/build/pages/terms.vue?macro=true";
import { default as logout5IefIawLVKi_45carVXSGd8rJdn2PmOXGvp0_45UW27XUp8Meta } from "/build/pages/logout.vue?macro=true";
import { default as contactYjd45lyRxBuy1KLgTksx61wM26CCLNovA4uMNh4fBfUMeta } from "/build/pages/contact.vue?macro=true";
import { default as viewZMFs6SMvlqpjwtD_45A_45Svh_NmaGEu5L8GIMTsd_45rjvUAMeta } from "/build/pages/cv/view.vue?macro=true";
import { default as indexdN_45JsSLI9wYhR8ypArxEqYJxCA3HeiPnEQmh0BC1tUMMeta } from "/build/pages/cv/index.vue?macro=true";
import { default as _91id_939lPh4WGhCX_fA1aqQFG6ATvVPsfii4JQSiEBpUWnIqYMeta } from "/build/pages/jobs/[id].vue?macro=true";
import { default as _91id_93GLgswIv7AtHhX_45CNZeZ3IS2Xrjn_9hXD01UywzCw8YQMeta } from "/build/pages/user/[id].vue?macro=true";
import { default as indexKOA9n0frsnGyL6exXe8UVwkgHo_45ICQBJl1sD2erazjQMeta } from "/build/pages/jobs/index.vue?macro=true";
import { default as _91id_93CXWiqHKwjEVDUyMg7h5GSP_155us6KsBr49Ij_45gu2sQMeta } from "/build/pages/teams/[id].vue?macro=true";
import { default as _91id_933Qi_45ZC6ULjSh63HuH7ME0ACuWU9Yo2hr1HYc4SScW0MMeta } from "/build/pages/events/[id].vue?macro=true";
import { default as indexbhFB7noWYsqP3Y8zTPWZWOQ7GZobGCnjaBdIuoA_4UoMeta } from "/build/pages/login/index.vue?macro=true";
import { default as indexm6XvYHgPdRRJjRkz4lfhI7czGE4ygqBLL77VsASHh1kMeta } from "/build/pages/teams/index.vue?macro=true";
import { default as _91id_938oYdjCKEwiY2AdHVl8HwvZ5ncRWaMAe6bFyyUSseZXUMeta } from "/build/pages/courses/[id].vue?macro=true";
import { default as faqsgTukbd85EA10EptKwO4W_6cKrleoMUgIrxyqSa1nh0AMeta } from "/build/pages/courses/faqs.vue?macro=true";
import { default as indexKiEqdgJ8cFJPJhRW_RvpicEgZxlMjyp7DAwq5RMz16wMeta } from "/build/pages/events/index.vue?macro=true";
import { default as indexR2S4U7Erh15LDnC_45pzTfjXGCDmLSO9h12nXlaukw8b4Meta } from "/build/pages/signup/index.vue?macro=true";
import { default as tasksN9YBEz6ZQWW9OJnvbF2hQ8eXdua_45Narfx6Z7rigE25EMeta } from "/build/pages/skills/tasks.vue?macro=true";
import { default as indexkLPovCpYcgQnZR9QOKwq1qO4_45inR_45vcd7yhS2iekaHwMeta } from "/build/pages/courses/index.vue?macro=true";
import { default as indexhAspwkO4dmWpciI9z37CbLNq_45KGv9TXNX4m7pm2qAugMeta } from "/build/pages/profile/index.vue?macro=true";
import { default as _91id_93_45CdMM13bYONT02uCnnVL_wbiitqDDvjq4bU7xgp6BYsMeta } from "/build/pages/employers/[id].vue?macro=true";
import { default as privacy_45policyzMiKEwjHCWM1omnPxQiFiUC0twgkPdAKBYKEDLYXKA0Meta } from "/build/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordl606_45aXwqbXSa4ltKxUbODz23Lw3_pEmVrHd_4573X38YMeta } from "/build/pages/reset-password.vue?macro=true";
import { default as index3DQXSGfSZ_45kHRSajDYVGI4eC_6Z_45XuyelEo_457wYC4QkMeta } from "/build/pages/settings/index.vue?macro=true";
import { default as techcareerfairYPuK3Bp7XVfjto_45tsSPtBWT3GbRgwDxF9y8iHjRhk3kMeta } from "/build/pages/techcareerfair.vue?macro=true";
import { default as indexancDNrs_45XJnePcfrpuy32rZFOp2lqKFOfzh4rPZguq8Meta } from "/build/pages/dashboard/index.vue?macro=true";
import { default as _91id_93DKY5Zixz0ltros4_3wqWj0KjXYw_s1HlEc_45vatvv_EwMeta } from "/build/pages/forum/post/[id].vue?macro=true";
import { default as saved_45jobs6Rki3fcOquEm_tLpB4g8bJ17apbnhCPMiHovnelMZWAMeta } from "/build/pages/jobs/saved-jobs.vue?macro=true";
import { default as cvKKeVwncbisHQwY6OEcJsNRSqR9EQ0SnWklr5GX1OQWYMeta } from "/build/pages/profile/[id]/cv.vue?macro=true";
import { default as indexuS80d8_45_45AeSSDOqRDISdL0dwe0N4Y0ldAPcaE7yWpAsMeta } from "/build/pages/subscribe/index.vue?macro=true";
import { default as be_45an_45instructor3DuquJ4eqKNrQzp5_45x9N_45Ho_45GEIpisnB6su4sFUkxB4Meta } from "/build/pages/be-an-instructor.vue?macro=true";
import { default as _91id_938sywNhA9sTbwPQd3Vq4Ig6oivOlaTPt1hDNoAncnvrcMeta } from "/build/pages/certificate/[id].vue?macro=true";
import { default as indexERH7JQRdL0eGaGAbDL_BvggrD2GsY_dwxXOP2OUkhHYMeta } from "/build/pages/forum/feed/index.vue?macro=true";
import { default as _91slug_93NSkaCWWUDn7tE3AJLyK2K4ipYD3tKrVneV_AdXK61gIMeta } from "/build/pages/forum/tag/[slug].vue?macro=true";
import { default as indexXIVyYrolSgIyOellriJC6Efch0eheuxPTWqI8IN8FkIMeta } from "/build/pages/programmes/index.vue?macro=true";
import { default as index4FXgYzkAgZKWShziJsCNyyOJJjjkkvmlkc5ILhpVUI4Meta } from "/build/pages/tests/[id]/index.vue?macro=true";
import { default as indexCi4gDaRGgy35C6wMRMpYji1CC_45U7JGtxxQGW2cQZivYMeta } from "/build/pages/forum/admin/index.vue?macro=true";
import { default as applied_45jobs_lOqCfQvkPYaoVIJw8Ojn4lmvIdZi86W8BJu3Oav9EQMeta } from "/build/pages/jobs/applied-jobs.vue?macro=true";
import { default as indexswtu2KPL5w65Q55XanwkEiq2DMeVmj9s_45S_45KhpBeGkgMeta } from "/build/pages/jobs/browse/index.vue?macro=true";
import { default as authqeEVGiVBSaTMjXmVAYed6LIgvB6Jd6fAWOAe5FdOZ4wMeta } from "/build/pages/login/oauth2/auth.vue?macro=true";
import { default as indexxe3lNKKke7g511HFd1_45B_45Zyd_457_45U_BYAsUEUW1wiB7IMeta } from "/build/pages/skills/home/index.vue?macro=true";
import { default as resultkiMq3ujIE1b_45SGiuI_45ejc7DTULrTsHPL0ACkIqWZKB0Meta } from "/build/pages/tests/[id]/result.vue?macro=true";
import { default as programmesGNcewNlaIRUQZ9cD24jbPpKxDGt5pbBNhvuEqTDlo10Meta } from "/build/pages/courses/programmes.vue?macro=true";
import { default as indexpynzosMLqod4_Qej6DnafwTeI2Ni03NhRAUwBeonpngMeta } from "/build/pages/forum/search/index.vue?macro=true";
import { default as indexkiKK5QQPmPK3QmkSkxIaxn6Nt6xZh5f8NMm0fGT2RAEMeta } from "/build/pages/profile/[id]/index.vue?macro=true";
import { default as indexz4PS80Y75mhjYB8WmEXsUwchgR7K37zydD_87yh9p8UMeta } from "/build/pages/profile/edit/index.vue?macro=true";
import { default as select_45roleTa9sqjbF6DpB_45EvMwCqr5iCsi0kEi2hiHyuWV2DE9B0Meta } from "/build/pages/signup/select-role.vue?macro=true";
import { default as indexmIBv9pUwHJyqTpSxFFt_dzJEQXzpQBjhBew2lLqDFaIMeta } from "/build/pages/skills/admin/index.vue?macro=true";
import { default as my_45learningdSbheStGK78C8X0h9u3xG8Yl8MgVClrZoqFZ6OPqxNUMeta } from "/build/pages/courses/my-learning.vue?macro=true";
import { default as indexdWXn4psm3aA6lCQf2mPVaYbq1W6lDrqHdw1RJvdlk_gMeta } from "/build/pages/forum/history/index.vue?macro=true";
import { default as indexCewdpAoSVkoUkDzjlEREMqWaIatuD7jybdvCopZ_E_MMeta } from "/build/pages/forum/support/index.vue?macro=true";
import { default as index32jB9JZdwkpZg3_r0ny10kdmy1uhIe7_45FAG4olbmT4cMeta } from "/build/pages/notifications/index.vue?macro=true";
import { default as completeDI6F_ju_459U3YvXzPdXihMs1uG6hDwdAXng_458hjpjw8wMeta } from "/build/pages/tests/[id]/complete.vue?macro=true";
import { default as indexhZRmAgpbbPoIvuD5JwN_45OS7xINPU16ioqFrQHZqgHgYMeta } from "/build/pages/courses/browse/index.vue?macro=true";
import { default as certificates0wzyjU43qMbtdyrL9oMWqwg2aySyemw9ycmWS5qsZS4Meta } from "/build/pages/courses/certificates.vue?macro=true";
import { default as _91id_9366L1kKFPp3q_g_I9sYAvldt7HaXR7b3WclwbsBc0IjEMeta } from "/build/pages/events/register/[id].vue?macro=true";
import { default as index7Y2pjsW6l0fzKPnjD43p19zEXWvblFhG12MGGWyUodEMeta } from "/build/pages/forum/bookmark/index.vue?macro=true";
import { default as indexdV1ASrnqccfHPYiLtOub_45qcO0jhEQiVFjZ6gKo5Y4XUMeta } from "/build/pages/forum/post/add/index.vue?macro=true";
import { default as _91id_93rM_45RSbEa8E8MPMc_3Ru_45g1_45mOHPngaMi_d9FFgR8sz8Meta } from "/build/pages/forum/post/edit/[id].vue?macro=true";
import { default as indexB51rKa5B0iYB2kaj_eyGZfCF3jy_Gye9YucFNUkKM94Meta } from "/build/pages/dashboard/admin/index.vue?macro=true";
import { default as indexY6Bl2duhSjl_vXae6LuoNeKgiy6Lm5_45QDIapFHWqPzoMeta } from "/build/pages/interviews/[id]/index.vue?macro=true";
import { default as index_uRn9TcCardZlWb3EyHCc7PWkg2HtOubdcHOmwpbBNkMeta } from "/build/pages/programmes/[id]/index.vue?macro=true";
import { default as disclaimer0_455s7EC5PcRyqTfzalIDaaOjTAg_lZzODjvgBvZP3ZYMeta } from "/build/pages/tests/[id]/disclaimer.vue?macro=true";
import { default as indexYKwGZUAIEU_45WEZJLfXhGMdBmEAmTCEV58hJHfL828TIMeta } from "/build/pages/events/thank-you/index.vue?macro=true";
import { default as index2rQ3XklZtTsKhlEDJTLNGJDNK8nVg84_45Z8g_45qrPLgmQMeta } from "/build/pages/forum/report/add/index.vue?macro=true";
import { default as indexUntpI37nvqp0mHcWXTtymMw6xqSa9wRD_45dIrLFb5KQEMeta } from "/build/pages/forum/report/all/index.vue?macro=true";
import { default as indexoYHbOU0ZlIwXNM4Q_H3GKrlhU_9hfGZRP4AvmpTYIgkMeta } from "/build/pages/forum/tag/browse/index.vue?macro=true";
import { default as reset_45password_45request4Og7u7gVEKuJ8Vda0D41EuiBkq4_4541NUc3Mq3yEsdykMeta } from "/build/pages/reset-password-request.vue?macro=true";
import { default as introduction67FWFc3O6sWjXyYe0lzCYoDiqjYLw88VCS5rgtGYBq8Meta } from "/build/pages/tests/[id]/introduction.vue?macro=true";
import { default as index1E1QvfdoflO4t_45ZxiLphDFHt6H6BoPAEKYveWGOSqk4Meta } from "/build/pages/forum/feed/for-you/index.vue?macro=true";
import { default as completeTQ3oJMZiUChkZH_9gRkYTEyPbWHtbB4sGGYG25PUU8AMeta } from "/build/pages/interviews/[id]/complete.vue?macro=true";
import { default as indexWBcAqjKijUnXLx2y1GwIq9UJ1cDLkyIiaUx7ITLcAd8Meta } from "/build/pages/profile/saved-jobs/index.vue?macro=true";
import { default as _91id_93ow_N_45KbBAo3YqoIpLcvTO8xvba5NGkB7ZK5rYdUdZRwMeta } from "/build/pages/programmes/register/[id].vue?macro=true";
import { default as result7ywexuPOog5Kq9OoOe_45Zc790SrlOyFwoUGjlrd1IdQcMeta } from "/build/pages/skills/tests/[id]/result.vue?macro=true";
import { default as messageVde1e8pt73AxxMt0ohF_8crnIhlvSXqyPMVFRwG5MugMeta } from "/build/pages/tests/[id]/error/message.vue?macro=true";
import { default as result_45review1vMXUmWpDZC_45DuqgCZVP32ZuRSaqNj5BpNYTuBpsko8Meta } from "/build/pages/tests/[id]/result-review.vue?macro=true";
import { default as _91id_93gMm37bBythg_45lpmT_45PJVHQXcxBmqrxMKaQDHLoqWYPkMeta } from "/build/pages/courses/learn/course/[id].vue?macro=true";
import { default as indexg5LC_KalBLFR3mLJ_45vDe0Nez4bDkJeAXbtxTysjqNnsMeta } from "/build/pages/forum/tag/following/index.vue?macro=true";
import { default as disclaimerH_45dtf7SYwHGnrwUjymIVAymIMysGn0wvO9UWgH2gWrwMeta } from "/build/pages/interviews/[id]/disclaimer.vue?macro=true";
import { default as next3Wonm1GQuYY_brj5SI_ZDUckwhu84FCiyA6Vx8KFs_45sMeta } from "/build/pages/interviews/[id]/error/next.vue?macro=true";
import { default as indexjRSemUdeVUwYu3EtYj5SubleP5SmYa0HNej9zmFnEPAMeta } from "/build/pages/profile/applied-jobs/index.vue?macro=true";
import { default as browser_45proctorhAuXmbaSNQJZL_pmVqirS4TssDmKoHO7tESS_45i2nM2wMeta } from "/build/pages/tests/[id]/browser-proctor.vue?macro=true";
import { default as technical_45checkMDMXm2wEoqw9aLANJv6TdpH4ItmBdtUDkx9iN4rlhGIMeta } from "/build/pages/tests/[id]/technical-check.vue?macro=true";
import { default as indexjv9DvvxB96OJDXwXduNRlv0ctPsl_45RMBPuhaulFIH7YMeta } from "/build/pages/forum/class-forum/add/index.vue?macro=true";
import { default as _91category_93oYriR2eO3oKM_45gSDWqFqZbwAOIzRVrs4ZHOK_45Y5GujYMeta } from "/build/pages/forum/tag/browse/[category].vue?macro=true";
import { default as index0iCbak8HcvnQd5_nTrwwOXeAjcLf6DGo0Exf4xtmNFsMeta } from "/build/pages/forum/history/comments/index.vue?macro=true";
import { default as introduction2uFHAdo_45ouq7uFfi1Pn2da_45d1C1_bJOGbbX__452WN3D8Meta } from "/build/pages/interviews/[id]/introduction.vue?macro=true";
import { default as indexNwS8hhMS_z4oLOlJlEqQr2kJGTKKgozZObHVxkkfo0UMeta } from "/build/pages/forum/bookmark/comments/index.vue?macro=true";
import { default as _91slug_93NKOL3wdfnzyhbFVxBj3ZmBi2ZDZUDt5MIgc1WWmkIwkMeta } from "/build/pages/forum/class-forum/edit/[slug].vue?macro=true";
import { default as messageVB_Kl69akAME3ChXiRk_45NJPCy1Nj0tBQImK0OJbgIQEMeta } from "/build/pages/interviews/[id]/error/message.vue?macro=true";
import { default as _91id_93e3Kl4UG2mM1ZdxT_45IQGjnKSMOq3O_45FfhXeYslK3jzsYMeta } from "/build/pages/courses/learn/certificate/[id].vue?macro=true";
import { default as indexghb_45YAzeGoNVdBy8j8R05_g9k5Z9yQcT7cFTKz0oO4cMeta } from "/build/pages/forum/class-forum/[slug]/index.vue?macro=true";
import { default as indexJt_SdUHEEKpR2P0s0awKiW1rjaLXnQJ1iIlxB5qr138Meta } from "/build/pages/skills/admin/assessments/index.vue?macro=true";
import { default as resultQBooMIPwJVlaNhwcUIfIHN5EJyMOJKk3RTyYQ6AUIDwMeta } from "/build/pages/skills/admin/tests/[id]/result.vue?macro=true";
import { default as technical_45check_VRf0pAnSO5hWqMDX1Bav01xXSITEjDcPJQZHyRokYMMeta } from "/build/pages/interviews/[id]/technical-check.vue?macro=true";
import { default as feedbackxhhjlxJvRtjKgNnw6BAqIHJ3RVX1hbZDe1QDNJR3oHsMeta } from "/build/pages/skills/interviews/[id]/feedback.vue?macro=true";
import { default as recordingym43BRv3L_450iCynxTWSEtcgztCL8ZinMm0XAAUP99TUMeta } from "/build/pages/skills/interviews/[id]/recording.vue?macro=true";
import { default as indexbi3_fzOdSZ0pyhkGrVAOAaHHbevBASWO9jnXyD5MCSQMeta } from "/build/pages/forum/history/announcements/index.vue?macro=true";
import { default as error__45sVYkr_9lvMhzDSIGXPDoH3aqxfXIMoDCDOyrmzt1YMeta } from "/build/pages/skills/admin/interviews/[id]/error.vue?macro=true";
import { default as _91commentId_93qZbYZMLgZL2pOxle9Z7Avts7lzivPE3oKa_45il3x5YPgMeta } from "/build/pages/forum/post/edit/comment/[commentId].vue?macro=true";
import { default as indexKzsBeof2ObI8JloDHFssGdqkU4Hks_45wdNzpJHoe6MfsMeta } from "/build/pages/forum/class-forum/[slug]/posts/index.vue?macro=true";
import { default as testeAVDgWpK2Ymeq3MrlENVd05_KNiH6bQD3x12hnGMHx0Meta } from "/build/pages/skills/admin/assessments/create/test.vue?macro=true";
import { default as indexRsSZ7KfvyT044vXhXE4H3ntR_4505NdX5NBhWZRhJqagEMeta } from "/build/pages/forum/class-forum/[slug]/pinned/index.vue?macro=true";
import { default as feedbackYhZJOPqdkEKCERfbRftUh5lcPu6qJaGVmvZVkKPqKngMeta } from "/build/pages/skills/admin/interviews/[id]/feedback.vue?macro=true";
import { default as indexUxRxmNJ4X6dEP_451PIfjeOSIOgUvrUXH_45h62Kdss9wWcMeta } from "/build/pages/forum/class-forum/[slug]/support/index.vue?macro=true";
import { default as index_Ibb_Xb0QHe_45s156w8E7X_MnO5EN1hPvWrTcWJCKYBoMeta } from "/build/pages/forum/class-forum/my-class-forum/index.vue?macro=true";
import { default as indexWbMmzi_45l4n8KMUdnhF37LmyKA0cgWTqUTsSMNC_45bX_45MMeta } from "/build/pages/programmes/student/my-programmes/index.vue?macro=true";
import { default as indexHEkdz7UivuMUOdboBG9xt87yfww_451QkjP8DSub7IVjgMeta } from "/build/pages/forum/class-forum/[slug]/students/index.vue?macro=true";
import { default as index_45anOaU5QNO6FUAIkmKktJr8WxxrGj3XQcgX17mnuxFkMeta } from "/build/pages/forum/class-forum/add-announcement/index.vue?macro=true";
import { default as _91id_93pwmlqb7xxCh3PqaxH7rIUYsiyqad__nkIX3XlPPPtOwMeta } from "/build/pages/forum/class-forum/edit-announcement/[id].vue?macro=true";
import { default as index_Y3RVhXJRhT__KCD0jnCfbUdAsJH3hsREfXTkaKscRsMeta } from "/build/pages/programmes/student/find-programmes/index.vue?macro=true";
import { default as edit8nu_NHQMmK7zIRkNAzKFt5scgqox1GewL3_45mPUlMJZUMeta } from "/build/pages/skills/admin/assessments/tests/[id]/edit.vue?macro=true";
import { default as indexmq3tv2NSDixzNIRSvYMyvBxP_45_fBb0l7Gju2BEgroMIMeta } from "/build/pages/forum/class-forum/[slug]/moderators/index.vue?macro=true";
import { default as indexR3Hd18CUFanBJTLB_45UW2ytkmXktTR1nJJqPzUKoNEA8Meta } from "/build/pages/forum/class-forum/add/[id]/students/index.vue?macro=true";
import { default as interviewZi8DouAcOD2fPL2_45Z3KyKupjmglfZwTWulf_PWb0r8wMeta } from "/build/pages/skills/admin/assessments/create/interview.vue?macro=true";
import { default as inviteEGVG4zDaVWASd3XgOlUy43aNN_aay0o5TF6aKx0T00gMeta } from "/build/pages/skills/admin/assessments/tests/[id]/invite.vue?macro=true";
import { default as index5gsp_Ts805MUv6ScKaV8ADrylmW4NKFPJP9JqPBMtAgMeta } from "/build/pages/forum/class-forum/add/[id]/moderators/index.vue?macro=true";
import { default as resultsKfS9QvmPmnfur71VVc9bOOocu4vJtSWUJkXHSQuj1bwMeta } from "/build/pages/skills/admin/assessments/tests/[id]/results.vue?macro=true";
import { default as indexfAHvYdXtChnl3pxNqQvnBqai3Bj0g01OPsifDq456tEMeta } from "/build/pages/forum/class-forum/[slug]/announcements/index.vue?macro=true";
import { default as editRoawuu5oAiSYiVaw5bCdhaMIZrSRJLlvf2wWg4AXGx4Meta } from "/build/pages/skills/admin/assessments/interviews/[id]/edit.vue?macro=true";
import { default as invite_45one6WuQUyHoqBBNvC5ugH5dwK53sRbBeVT83Lnu_45yQMfr4Meta } from "/build/pages/skills/admin/assessments/tests/[id]/invite-one.vue?macro=true";
import { default as _91id_93Uu0pQ7yz01NEIlWFxypTRnxc3rlHADWyTLKVWlJpIbsMeta } from "/build/pages/classroom/learn/[courseName]/[contentType]/[id].vue?macro=true";
import { default as invitebktcILa5szvD0H8zw7dAgQgkpzLSGgVoZwVnlQ_uXmAMeta } from "/build/pages/skills/admin/assessments/interviews/[id]/invite.vue?macro=true";
import { default as results8mbySP59w34iROG8zBJN06Br8z3EVzqM3mlaKSxvYP8Meta } from "/build/pages/skills/admin/assessments/interviews/[id]/results.vue?macro=true";
import { default as invite_45one_QpIx1oMx70tzhIiCseIy6T7SlaK2t4TLyHjwUVrv_450Meta } from "/build/pages/skills/admin/assessments/interviews/[id]/invite-one.vue?macro=true";
import { default as component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta } from "/build/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8 } from "/build/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "test___en___default",
    path: "/test",
    component: () => import("/build/pages/test.vue")
  },
  {
    name: "test___en",
    path: "/en/test",
    component: () => import("/build/pages/test.vue")
  },
  {
    name: "about___en___default",
    path: "/about",
    meta: aboutPxBLKIZlPRBLW8MmpGINvd4MmfZ0Ma8OD7o5tWt6idwMeta || {},
    component: () => import("/build/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutPxBLKIZlPRBLW8MmpGINvd4MmfZ0Ma8OD7o5tWt6idwMeta || {},
    component: () => import("/build/pages/about.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    meta: indexfaSkdcsHLeb812gzXZAgK_hEZEnndCv3Vs4JNO6v_aQMeta || {},
    component: () => import("/build/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexfaSkdcsHLeb812gzXZAgK_hEZEnndCv3Vs4JNO6v_aQMeta || {},
    component: () => import("/build/pages/index.vue")
  },
  {
    name: "terms___en___default",
    path: "/terms",
    component: () => import("/build/pages/terms.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms",
    component: () => import("/build/pages/terms.vue")
  },
  {
    name: "logout___en___default",
    path: "/logout",
    meta: logout5IefIawLVKi_45carVXSGd8rJdn2PmOXGvp0_45UW27XUp8Meta || {},
    component: () => import("/build/pages/logout.vue")
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logout5IefIawLVKi_45carVXSGd8rJdn2PmOXGvp0_45UW27XUp8Meta || {},
    component: () => import("/build/pages/logout.vue")
  },
  {
    name: "contact___en___default",
    path: "/contact",
    meta: contactYjd45lyRxBuy1KLgTksx61wM26CCLNovA4uMNh4fBfUMeta || {},
    component: () => import("/build/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    meta: contactYjd45lyRxBuy1KLgTksx61wM26CCLNovA4uMNh4fBfUMeta || {},
    component: () => import("/build/pages/contact.vue")
  },
  {
    name: "cv-view___en___default",
    path: "/cv/view",
    meta: { ...(viewZMFs6SMvlqpjwtD_45A_45Svh_NmaGEu5L8GIMTsd_45rjvUAMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/cv/view.vue")
  },
  {
    name: "cv-view___en",
    path: "/en/cv/view",
    meta: { ...(viewZMFs6SMvlqpjwtD_45A_45Svh_NmaGEu5L8GIMTsd_45rjvUAMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/cv/view.vue")
  },
  {
    name: "cv___en___default",
    path: "/cv",
    meta: { ...(indexdN_45JsSLI9wYhR8ypArxEqYJxCA3HeiPnEQmh0BC1tUMMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/cv/index.vue")
  },
  {
    name: "cv___en",
    path: "/en/cv",
    meta: { ...(indexdN_45JsSLI9wYhR8ypArxEqYJxCA3HeiPnEQmh0BC1tUMMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/cv/index.vue")
  },
  {
    name: "jobs-id___en___default",
    path: "/jobs/:id()",
    meta: _91id_939lPh4WGhCX_fA1aqQFG6ATvVPsfii4JQSiEBpUWnIqYMeta || {},
    component: () => import("/build/pages/jobs/[id].vue")
  },
  {
    name: "jobs-id___en",
    path: "/en/jobs/:id()",
    meta: _91id_939lPh4WGhCX_fA1aqQFG6ATvVPsfii4JQSiEBpUWnIqYMeta || {},
    component: () => import("/build/pages/jobs/[id].vue")
  },
  {
    name: "user-id___en___default",
    path: "/user/:id()",
    meta: _91id_93GLgswIv7AtHhX_45CNZeZ3IS2Xrjn_9hXD01UywzCw8YQMeta || {},
    component: () => import("/build/pages/user/[id].vue")
  },
  {
    name: "user-id___en",
    path: "/en/user/:id()",
    meta: _91id_93GLgswIv7AtHhX_45CNZeZ3IS2Xrjn_9hXD01UywzCw8YQMeta || {},
    component: () => import("/build/pages/user/[id].vue")
  },
  {
    name: "jobs___en___default",
    path: "/jobs",
    meta: indexKOA9n0frsnGyL6exXe8UVwkgHo_45ICQBJl1sD2erazjQMeta || {},
    component: () => import("/build/pages/jobs/index.vue")
  },
  {
    name: "jobs___en",
    path: "/en/jobs",
    meta: indexKOA9n0frsnGyL6exXe8UVwkgHo_45ICQBJl1sD2erazjQMeta || {},
    component: () => import("/build/pages/jobs/index.vue")
  },
  {
    name: "teams-id___en___default",
    path: "/teams/:id()",
    component: () => import("/build/pages/teams/[id].vue")
  },
  {
    name: "teams-id___en",
    path: "/en/teams/:id()",
    component: () => import("/build/pages/teams/[id].vue")
  },
  {
    name: "events-id___en___default",
    path: "/events/:id()",
    meta: _91id_933Qi_45ZC6ULjSh63HuH7ME0ACuWU9Yo2hr1HYc4SScW0MMeta || {},
    component: () => import("/build/pages/events/[id].vue")
  },
  {
    name: "events-id___en",
    path: "/en/events/:id()",
    meta: _91id_933Qi_45ZC6ULjSh63HuH7ME0ACuWU9Yo2hr1HYc4SScW0MMeta || {},
    component: () => import("/build/pages/events/[id].vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    meta: indexbhFB7noWYsqP3Y8zTPWZWOQ7GZobGCnjaBdIuoA_4UoMeta || {},
    component: () => import("/build/pages/login/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: indexbhFB7noWYsqP3Y8zTPWZWOQ7GZobGCnjaBdIuoA_4UoMeta || {},
    component: () => import("/build/pages/login/index.vue")
  },
  {
    name: "teams___en___default",
    path: "/teams",
    meta: indexm6XvYHgPdRRJjRkz4lfhI7czGE4ygqBLL77VsASHh1kMeta || {},
    component: () => import("/build/pages/teams/index.vue")
  },
  {
    name: "teams___en",
    path: "/en/teams",
    meta: indexm6XvYHgPdRRJjRkz4lfhI7czGE4ygqBLL77VsASHh1kMeta || {},
    component: () => import("/build/pages/teams/index.vue")
  },
  {
    name: "courses-id___en___default",
    path: "/courses/:id()",
    meta: _91id_938oYdjCKEwiY2AdHVl8HwvZ5ncRWaMAe6bFyyUSseZXUMeta || {},
    component: () => import("/build/pages/courses/[id].vue")
  },
  {
    name: "courses-id___en",
    path: "/en/courses/:id()",
    meta: _91id_938oYdjCKEwiY2AdHVl8HwvZ5ncRWaMAe6bFyyUSseZXUMeta || {},
    component: () => import("/build/pages/courses/[id].vue")
  },
  {
    name: "courses-faqs___en___default",
    path: "/courses/faqs",
    meta: faqsgTukbd85EA10EptKwO4W_6cKrleoMUgIrxyqSa1nh0AMeta || {},
    component: () => import("/build/pages/courses/faqs.vue")
  },
  {
    name: "courses-faqs___en",
    path: "/en/courses/faqs",
    meta: faqsgTukbd85EA10EptKwO4W_6cKrleoMUgIrxyqSa1nh0AMeta || {},
    component: () => import("/build/pages/courses/faqs.vue")
  },
  {
    name: "events___en___default",
    path: "/events",
    meta: indexKiEqdgJ8cFJPJhRW_RvpicEgZxlMjyp7DAwq5RMz16wMeta || {},
    component: () => import("/build/pages/events/index.vue")
  },
  {
    name: "events___en",
    path: "/en/events",
    meta: indexKiEqdgJ8cFJPJhRW_RvpicEgZxlMjyp7DAwq5RMz16wMeta || {},
    component: () => import("/build/pages/events/index.vue")
  },
  {
    name: "signup___en___default",
    path: "/signup",
    meta: indexR2S4U7Erh15LDnC_45pzTfjXGCDmLSO9h12nXlaukw8b4Meta || {},
    component: () => import("/build/pages/signup/index.vue")
  },
  {
    name: "signup___en",
    path: "/en/signup",
    meta: indexR2S4U7Erh15LDnC_45pzTfjXGCDmLSO9h12nXlaukw8b4Meta || {},
    component: () => import("/build/pages/signup/index.vue")
  },
  {
    name: "skills-tasks___en___default",
    path: "/skills/tasks",
    meta: { ...(tasksN9YBEz6ZQWW9OJnvbF2hQ8eXdua_45Narfx6Z7rigE25EMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/tasks.vue")
  },
  {
    name: "skills-tasks___en",
    path: "/en/skills/tasks",
    meta: { ...(tasksN9YBEz6ZQWW9OJnvbF2hQ8eXdua_45Narfx6Z7rigE25EMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/tasks.vue")
  },
  {
    name: "courses___en___default",
    path: "/courses",
    meta: indexkLPovCpYcgQnZR9QOKwq1qO4_45inR_45vcd7yhS2iekaHwMeta || {},
    component: () => import("/build/pages/courses/index.vue")
  },
  {
    name: "courses___en",
    path: "/en/courses",
    meta: indexkLPovCpYcgQnZR9QOKwq1qO4_45inR_45vcd7yhS2iekaHwMeta || {},
    component: () => import("/build/pages/courses/index.vue")
  },
  {
    name: "profile___en___default",
    path: "/profile",
    meta: { ...(indexhAspwkO4dmWpciI9z37CbLNq_45KGv9TXNX4m7pm2qAugMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/index.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: { ...(indexhAspwkO4dmWpciI9z37CbLNq_45KGv9TXNX4m7pm2qAugMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/index.vue")
  },
  {
    name: "employers-id___en___default",
    path: "/employers/:id()",
    meta: _91id_93_45CdMM13bYONT02uCnnVL_wbiitqDDvjq4bU7xgp6BYsMeta || {},
    component: () => import("/build/pages/employers/[id].vue")
  },
  {
    name: "employers-id___en",
    path: "/en/employers/:id()",
    meta: _91id_93_45CdMM13bYONT02uCnnVL_wbiitqDDvjq4bU7xgp6BYsMeta || {},
    component: () => import("/build/pages/employers/[id].vue")
  },
  {
    name: "privacy-policy___en___default",
    path: "/privacy-policy",
    component: () => import("/build/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/build/pages/privacy-policy.vue")
  },
  {
    name: "reset-password___en___default",
    path: "/reset-password",
    meta: reset_45passwordl606_45aXwqbXSa4ltKxUbODz23Lw3_pEmVrHd_4573X38YMeta || {},
    component: () => import("/build/pages/reset-password.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    meta: reset_45passwordl606_45aXwqbXSa4ltKxUbODz23Lw3_pEmVrHd_4573X38YMeta || {},
    component: () => import("/build/pages/reset-password.vue")
  },
  {
    name: "settings___en___default",
    path: "/settings",
    meta: { ...(index3DQXSGfSZ_45kHRSajDYVGI4eC_6Z_45XuyelEo_457wYC4QkMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/settings/index.vue")
  },
  {
    name: "settings___en",
    path: "/en/settings",
    meta: { ...(index3DQXSGfSZ_45kHRSajDYVGI4eC_6Z_45XuyelEo_457wYC4QkMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/settings/index.vue")
  },
  {
    name: "techcareerfair___en___default",
    path: "/techcareerfair",
    component: () => import("/build/pages/techcareerfair.vue")
  },
  {
    name: "techcareerfair___en",
    path: "/en/techcareerfair",
    component: () => import("/build/pages/techcareerfair.vue")
  },
  {
    name: "dashboard___en___default",
    path: "/dashboard",
    meta: { ...(indexancDNrs_45XJnePcfrpuy32rZFOp2lqKFOfzh4rPZguq8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___en",
    path: "/en/dashboard",
    meta: { ...(indexancDNrs_45XJnePcfrpuy32rZFOp2lqKFOfzh4rPZguq8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/dashboard/index.vue")
  },
  {
    name: "forum-post-id___en___default",
    path: "/forum/post/:id()",
    meta: _91id_93DKY5Zixz0ltros4_3wqWj0KjXYw_s1HlEc_45vatvv_EwMeta || {},
    component: () => import("/build/pages/forum/post/[id].vue")
  },
  {
    name: "forum-post-id___en",
    path: "/en/forum/post/:id()",
    meta: _91id_93DKY5Zixz0ltros4_3wqWj0KjXYw_s1HlEc_45vatvv_EwMeta || {},
    component: () => import("/build/pages/forum/post/[id].vue")
  },
  {
    name: "jobs-saved-jobs___en___default",
    path: "/jobs/saved-jobs",
    meta: { ...(saved_45jobs6Rki3fcOquEm_tLpB4g8bJ17apbnhCPMiHovnelMZWAMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/jobs/saved-jobs.vue")
  },
  {
    name: "jobs-saved-jobs___en",
    path: "/en/jobs/saved-jobs",
    meta: { ...(saved_45jobs6Rki3fcOquEm_tLpB4g8bJ17apbnhCPMiHovnelMZWAMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/jobs/saved-jobs.vue")
  },
  {
    name: "profile-id-cv___en___default",
    path: "/profile/:id()/cv",
    meta: { ...(cvKKeVwncbisHQwY6OEcJsNRSqR9EQ0SnWklr5GX1OQWYMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/[id]/cv.vue")
  },
  {
    name: "profile-id-cv___en",
    path: "/en/profile/:id()/cv",
    meta: { ...(cvKKeVwncbisHQwY6OEcJsNRSqR9EQ0SnWklr5GX1OQWYMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/[id]/cv.vue")
  },
  {
    name: "subscribe___en___default",
    path: "/subscribe",
    meta: indexuS80d8_45_45AeSSDOqRDISdL0dwe0N4Y0ldAPcaE7yWpAsMeta || {},
    component: () => import("/build/pages/subscribe/index.vue")
  },
  {
    name: "subscribe___en",
    path: "/en/subscribe",
    meta: indexuS80d8_45_45AeSSDOqRDISdL0dwe0N4Y0ldAPcaE7yWpAsMeta || {},
    component: () => import("/build/pages/subscribe/index.vue")
  },
  {
    name: "be-an-instructor___en___default",
    path: "/be-an-instructor",
    meta: be_45an_45instructor3DuquJ4eqKNrQzp5_45x9N_45Ho_45GEIpisnB6su4sFUkxB4Meta || {},
    component: () => import("/build/pages/be-an-instructor.vue")
  },
  {
    name: "be-an-instructor___en",
    path: "/en/be-an-instructor",
    meta: be_45an_45instructor3DuquJ4eqKNrQzp5_45x9N_45Ho_45GEIpisnB6su4sFUkxB4Meta || {},
    component: () => import("/build/pages/be-an-instructor.vue")
  },
  {
    name: "certificate-id___en___default",
    path: "/certificate/:id()",
    meta: _91id_938sywNhA9sTbwPQd3Vq4Ig6oivOlaTPt1hDNoAncnvrcMeta || {},
    component: () => import("/build/pages/certificate/[id].vue")
  },
  {
    name: "certificate-id___en",
    path: "/en/certificate/:id()",
    meta: _91id_938sywNhA9sTbwPQd3Vq4Ig6oivOlaTPt1hDNoAncnvrcMeta || {},
    component: () => import("/build/pages/certificate/[id].vue")
  },
  {
    name: "forum-feed___en___default",
    path: "/forum/feed",
    meta: indexERH7JQRdL0eGaGAbDL_BvggrD2GsY_dwxXOP2OUkhHYMeta || {},
    component: () => import("/build/pages/forum/feed/index.vue")
  },
  {
    name: "forum-feed___en",
    path: "/en/forum/feed",
    meta: indexERH7JQRdL0eGaGAbDL_BvggrD2GsY_dwxXOP2OUkhHYMeta || {},
    component: () => import("/build/pages/forum/feed/index.vue")
  },
  {
    name: "forum-tag-slug___en___default",
    path: "/forum/tag/:slug()",
    meta: _91slug_93NSkaCWWUDn7tE3AJLyK2K4ipYD3tKrVneV_AdXK61gIMeta || {},
    component: () => import("/build/pages/forum/tag/[slug].vue")
  },
  {
    name: "forum-tag-slug___en",
    path: "/en/forum/tag/:slug()",
    meta: _91slug_93NSkaCWWUDn7tE3AJLyK2K4ipYD3tKrVneV_AdXK61gIMeta || {},
    component: () => import("/build/pages/forum/tag/[slug].vue")
  },
  {
    name: "programmes___en___default",
    path: "/programmes",
    meta: indexXIVyYrolSgIyOellriJC6Efch0eheuxPTWqI8IN8FkIMeta || {},
    component: () => import("/build/pages/programmes/index.vue")
  },
  {
    name: "programmes___en",
    path: "/en/programmes",
    meta: indexXIVyYrolSgIyOellriJC6Efch0eheuxPTWqI8IN8FkIMeta || {},
    component: () => import("/build/pages/programmes/index.vue")
  },
  {
    name: "tests-id___en___default",
    path: "/tests/:id()",
    meta: {"middleware":"authcheck"},
    component: () => import("/build/pages/tests/[id]/index.vue")
  },
  {
    name: "tests-id___en",
    path: "/en/tests/:id()",
    meta: {"middleware":"authcheck"},
    component: () => import("/build/pages/tests/[id]/index.vue")
  },
  {
    name: "forum-admin___en___default",
    path: "/forum/admin",
    meta: { ...(indexCi4gDaRGgy35C6wMRMpYji1CC_45U7JGtxxQGW2cQZivYMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/admin/index.vue")
  },
  {
    name: "forum-admin___en",
    path: "/en/forum/admin",
    meta: { ...(indexCi4gDaRGgy35C6wMRMpYji1CC_45U7JGtxxQGW2cQZivYMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/admin/index.vue")
  },
  {
    name: "jobs-applied-jobs___en___default",
    path: "/jobs/applied-jobs",
    meta: { ...(applied_45jobs_lOqCfQvkPYaoVIJw8Ojn4lmvIdZi86W8BJu3Oav9EQMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/jobs/applied-jobs.vue")
  },
  {
    name: "jobs-applied-jobs___en",
    path: "/en/jobs/applied-jobs",
    meta: { ...(applied_45jobs_lOqCfQvkPYaoVIJw8Ojn4lmvIdZi86W8BJu3Oav9EQMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/jobs/applied-jobs.vue")
  },
  {
    name: "jobs-browse___en___default",
    path: "/jobs/browse",
    meta: { ...(indexswtu2KPL5w65Q55XanwkEiq2DMeVmj9s_45S_45KhpBeGkgMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/jobs/browse/index.vue")
  },
  {
    name: "jobs-browse___en",
    path: "/en/jobs/browse",
    meta: { ...(indexswtu2KPL5w65Q55XanwkEiq2DMeVmj9s_45S_45KhpBeGkgMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/jobs/browse/index.vue")
  },
  {
    name: "login-oauth2-auth___en___default",
    path: "/login/oauth2/auth",
    meta: authqeEVGiVBSaTMjXmVAYed6LIgvB6Jd6fAWOAe5FdOZ4wMeta || {},
    component: () => import("/build/pages/login/oauth2/auth.vue")
  },
  {
    name: "login-oauth2-auth___en",
    path: "/en/login/oauth2/auth",
    meta: authqeEVGiVBSaTMjXmVAYed6LIgvB6Jd6fAWOAe5FdOZ4wMeta || {},
    component: () => import("/build/pages/login/oauth2/auth.vue")
  },
  {
    name: "skills-home___en___default",
    path: "/skills/home",
    meta: { ...(indexxe3lNKKke7g511HFd1_45B_45Zyd_457_45U_BYAsUEUW1wiB7IMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/home/index.vue")
  },
  {
    name: "skills-home___en",
    path: "/en/skills/home",
    meta: { ...(indexxe3lNKKke7g511HFd1_45B_45Zyd_457_45U_BYAsUEUW1wiB7IMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/home/index.vue")
  },
  {
    name: "tests-id-result___en___default",
    path: "/tests/:id()/result",
    meta: { ...(resultkiMq3ujIE1b_45SGiuI_45ejc7DTULrTsHPL0ACkIqWZKB0Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/result.vue")
  },
  {
    name: "tests-id-result___en",
    path: "/en/tests/:id()/result",
    meta: { ...(resultkiMq3ujIE1b_45SGiuI_45ejc7DTULrTsHPL0ACkIqWZKB0Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/result.vue")
  },
  {
    name: "courses-programmes___en___default",
    path: "/courses/programmes",
    meta: { ...(programmesGNcewNlaIRUQZ9cD24jbPpKxDGt5pbBNhvuEqTDlo10Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/programmes.vue")
  },
  {
    name: "courses-programmes___en",
    path: "/en/courses/programmes",
    meta: { ...(programmesGNcewNlaIRUQZ9cD24jbPpKxDGt5pbBNhvuEqTDlo10Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/programmes.vue")
  },
  {
    name: "forum-search___en___default",
    path: "/forum/search",
    meta: indexpynzosMLqod4_Qej6DnafwTeI2Ni03NhRAUwBeonpngMeta || {},
    component: () => import("/build/pages/forum/search/index.vue")
  },
  {
    name: "forum-search___en",
    path: "/en/forum/search",
    meta: indexpynzosMLqod4_Qej6DnafwTeI2Ni03NhRAUwBeonpngMeta || {},
    component: () => import("/build/pages/forum/search/index.vue")
  },
  {
    name: "profile-id___en___default",
    path: "/profile/:id()",
    meta: indexkiKK5QQPmPK3QmkSkxIaxn6Nt6xZh5f8NMm0fGT2RAEMeta || {},
    component: () => import("/build/pages/profile/[id]/index.vue")
  },
  {
    name: "profile-id___en",
    path: "/en/profile/:id()",
    meta: indexkiKK5QQPmPK3QmkSkxIaxn6Nt6xZh5f8NMm0fGT2RAEMeta || {},
    component: () => import("/build/pages/profile/[id]/index.vue")
  },
  {
    name: "profile-edit___en___default",
    path: "/profile/edit",
    meta: { ...(indexz4PS80Y75mhjYB8WmEXsUwchgR7K37zydD_87yh9p8UMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/edit/index.vue")
  },
  {
    name: "profile-edit___en",
    path: "/en/profile/edit",
    meta: { ...(indexz4PS80Y75mhjYB8WmEXsUwchgR7K37zydD_87yh9p8UMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/edit/index.vue")
  },
  {
    name: "signup-select-role___en___default",
    path: "/signup/select-role",
    meta: select_45roleTa9sqjbF6DpB_45EvMwCqr5iCsi0kEi2hiHyuWV2DE9B0Meta || {},
    component: () => import("/build/pages/signup/select-role.vue")
  },
  {
    name: "signup-select-role___en",
    path: "/en/signup/select-role",
    meta: select_45roleTa9sqjbF6DpB_45EvMwCqr5iCsi0kEi2hiHyuWV2DE9B0Meta || {},
    component: () => import("/build/pages/signup/select-role.vue")
  },
  {
    name: "skills-admin___en___default",
    path: "/skills/admin",
    meta: { ...(indexmIBv9pUwHJyqTpSxFFt_dzJEQXzpQBjhBew2lLqDFaIMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/index.vue")
  },
  {
    name: "skills-admin___en",
    path: "/en/skills/admin",
    meta: { ...(indexmIBv9pUwHJyqTpSxFFt_dzJEQXzpQBjhBew2lLqDFaIMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/index.vue")
  },
  {
    name: "courses-my-learning___en___default",
    path: "/courses/my-learning",
    meta: { ...(my_45learningdSbheStGK78C8X0h9u3xG8Yl8MgVClrZoqFZ6OPqxNUMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/my-learning.vue")
  },
  {
    name: "courses-my-learning___en",
    path: "/en/courses/my-learning",
    meta: { ...(my_45learningdSbheStGK78C8X0h9u3xG8Yl8MgVClrZoqFZ6OPqxNUMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/my-learning.vue")
  },
  {
    name: "forum-history___en___default",
    path: "/forum/history",
    meta: { ...(indexdWXn4psm3aA6lCQf2mPVaYbq1W6lDrqHdw1RJvdlk_gMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/history/index.vue")
  },
  {
    name: "forum-history___en",
    path: "/en/forum/history",
    meta: { ...(indexdWXn4psm3aA6lCQf2mPVaYbq1W6lDrqHdw1RJvdlk_gMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/history/index.vue")
  },
  {
    name: "forum-support___en___default",
    path: "/forum/support",
    meta: { ...(indexCewdpAoSVkoUkDzjlEREMqWaIatuD7jybdvCopZ_E_MMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/support/index.vue")
  },
  {
    name: "forum-support___en",
    path: "/en/forum/support",
    meta: { ...(indexCewdpAoSVkoUkDzjlEREMqWaIatuD7jybdvCopZ_E_MMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/support/index.vue")
  },
  {
    name: "notifications___en___default",
    path: "/notifications",
    meta: { ...(index32jB9JZdwkpZg3_r0ny10kdmy1uhIe7_45FAG4olbmT4cMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/notifications/index.vue")
  },
  {
    name: "notifications___en",
    path: "/en/notifications",
    meta: { ...(index32jB9JZdwkpZg3_r0ny10kdmy1uhIe7_45FAG4olbmT4cMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/notifications/index.vue")
  },
  {
    name: "tests-id-complete___en___default",
    path: "/tests/:id()/complete",
    meta: { ...(completeDI6F_ju_459U3YvXzPdXihMs1uG6hDwdAXng_458hjpjw8wMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/complete.vue")
  },
  {
    name: "tests-id-complete___en",
    path: "/en/tests/:id()/complete",
    meta: { ...(completeDI6F_ju_459U3YvXzPdXihMs1uG6hDwdAXng_458hjpjw8wMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/complete.vue")
  },
  {
    name: "courses-browse___en___default",
    path: "/courses/browse",
    meta: { ...(indexhZRmAgpbbPoIvuD5JwN_45OS7xINPU16ioqFrQHZqgHgYMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/browse/index.vue")
  },
  {
    name: "courses-browse___en",
    path: "/en/courses/browse",
    meta: { ...(indexhZRmAgpbbPoIvuD5JwN_45OS7xINPU16ioqFrQHZqgHgYMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/browse/index.vue")
  },
  {
    name: "courses-certificates___en___default",
    path: "/courses/certificates",
    meta: { ...(certificates0wzyjU43qMbtdyrL9oMWqwg2aySyemw9ycmWS5qsZS4Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/certificates.vue")
  },
  {
    name: "courses-certificates___en",
    path: "/en/courses/certificates",
    meta: { ...(certificates0wzyjU43qMbtdyrL9oMWqwg2aySyemw9ycmWS5qsZS4Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/certificates.vue")
  },
  {
    name: "events-register-id___en___default",
    path: "/events/register/:id()",
    meta: _91id_9366L1kKFPp3q_g_I9sYAvldt7HaXR7b3WclwbsBc0IjEMeta || {},
    component: () => import("/build/pages/events/register/[id].vue")
  },
  {
    name: "events-register-id___en",
    path: "/en/events/register/:id()",
    meta: _91id_9366L1kKFPp3q_g_I9sYAvldt7HaXR7b3WclwbsBc0IjEMeta || {},
    component: () => import("/build/pages/events/register/[id].vue")
  },
  {
    name: "forum-bookmark___en___default",
    path: "/forum/bookmark",
    meta: { ...(index7Y2pjsW6l0fzKPnjD43p19zEXWvblFhG12MGGWyUodEMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/bookmark/index.vue")
  },
  {
    name: "forum-bookmark___en",
    path: "/en/forum/bookmark",
    meta: { ...(index7Y2pjsW6l0fzKPnjD43p19zEXWvblFhG12MGGWyUodEMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/bookmark/index.vue")
  },
  {
    name: "forum-post-add___en___default",
    path: "/forum/post/add",
    meta: { ...(indexdV1ASrnqccfHPYiLtOub_45qcO0jhEQiVFjZ6gKo5Y4XUMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/post/add/index.vue")
  },
  {
    name: "forum-post-add___en",
    path: "/en/forum/post/add",
    meta: { ...(indexdV1ASrnqccfHPYiLtOub_45qcO0jhEQiVFjZ6gKo5Y4XUMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/post/add/index.vue")
  },
  {
    name: "forum-post-edit-id___en___default",
    path: "/forum/post/edit/:id()",
    meta: { ...(_91id_93rM_45RSbEa8E8MPMc_3Ru_45g1_45mOHPngaMi_d9FFgR8sz8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/post/edit/[id].vue")
  },
  {
    name: "forum-post-edit-id___en",
    path: "/en/forum/post/edit/:id()",
    meta: { ...(_91id_93rM_45RSbEa8E8MPMc_3Ru_45g1_45mOHPngaMi_d9FFgR8sz8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/post/edit/[id].vue")
  },
  {
    name: "dashboard-admin___en___default",
    path: "/dashboard/admin",
    meta: { ...(indexB51rKa5B0iYB2kaj_eyGZfCF3jy_Gye9YucFNUkKM94Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/dashboard/admin/index.vue")
  },
  {
    name: "dashboard-admin___en",
    path: "/en/dashboard/admin",
    meta: { ...(indexB51rKa5B0iYB2kaj_eyGZfCF3jy_Gye9YucFNUkKM94Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/dashboard/admin/index.vue")
  },
  {
    name: "interviews-id___en___default",
    path: "/interviews/:id()",
    meta: {"middleware":"authcheck"},
    component: () => import("/build/pages/interviews/[id]/index.vue")
  },
  {
    name: "interviews-id___en",
    path: "/en/interviews/:id()",
    meta: {"middleware":"authcheck"},
    component: () => import("/build/pages/interviews/[id]/index.vue")
  },
  {
    name: "programmes-id___en___default",
    path: "/programmes/:id()",
    meta: index_uRn9TcCardZlWb3EyHCc7PWkg2HtOubdcHOmwpbBNkMeta || {},
    component: () => import("/build/pages/programmes/[id]/index.vue")
  },
  {
    name: "programmes-id___en",
    path: "/en/programmes/:id()",
    meta: index_uRn9TcCardZlWb3EyHCc7PWkg2HtOubdcHOmwpbBNkMeta || {},
    component: () => import("/build/pages/programmes/[id]/index.vue")
  },
  {
    name: "tests-id-disclaimer___en___default",
    path: "/tests/:id()/disclaimer",
    component: () => import("/build/pages/tests/[id]/disclaimer.vue")
  },
  {
    name: "tests-id-disclaimer___en",
    path: "/en/tests/:id()/disclaimer",
    component: () => import("/build/pages/tests/[id]/disclaimer.vue")
  },
  {
    name: "events-thank-you___en___default",
    path: "/events/thank-you",
    meta: { ...(indexYKwGZUAIEU_45WEZJLfXhGMdBmEAmTCEV58hJHfL828TIMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/events/thank-you/index.vue")
  },
  {
    name: "events-thank-you___en",
    path: "/en/events/thank-you",
    meta: { ...(indexYKwGZUAIEU_45WEZJLfXhGMdBmEAmTCEV58hJHfL828TIMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/events/thank-you/index.vue")
  },
  {
    name: "forum-report-add___en___default",
    path: "/forum/report/add",
    meta: { ...(index2rQ3XklZtTsKhlEDJTLNGJDNK8nVg84_45Z8g_45qrPLgmQMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/report/add/index.vue")
  },
  {
    name: "forum-report-add___en",
    path: "/en/forum/report/add",
    meta: { ...(index2rQ3XklZtTsKhlEDJTLNGJDNK8nVg84_45Z8g_45qrPLgmQMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/report/add/index.vue")
  },
  {
    name: "forum-report-all___en___default",
    path: "/forum/report/all",
    meta: { ...(indexUntpI37nvqp0mHcWXTtymMw6xqSa9wRD_45dIrLFb5KQEMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/report/all/index.vue")
  },
  {
    name: "forum-report-all___en",
    path: "/en/forum/report/all",
    meta: { ...(indexUntpI37nvqp0mHcWXTtymMw6xqSa9wRD_45dIrLFb5KQEMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/report/all/index.vue")
  },
  {
    name: "forum-tag-browse___en___default",
    path: "/forum/tag/browse",
    meta: indexoYHbOU0ZlIwXNM4Q_H3GKrlhU_9hfGZRP4AvmpTYIgkMeta || {},
    component: () => import("/build/pages/forum/tag/browse/index.vue")
  },
  {
    name: "forum-tag-browse___en",
    path: "/en/forum/tag/browse",
    meta: indexoYHbOU0ZlIwXNM4Q_H3GKrlhU_9hfGZRP4AvmpTYIgkMeta || {},
    component: () => import("/build/pages/forum/tag/browse/index.vue")
  },
  {
    name: "reset-password-request___en___default",
    path: "/reset-password-request",
    meta: reset_45password_45request4Og7u7gVEKuJ8Vda0D41EuiBkq4_4541NUc3Mq3yEsdykMeta || {},
    component: () => import("/build/pages/reset-password-request.vue")
  },
  {
    name: "reset-password-request___en",
    path: "/en/reset-password-request",
    meta: reset_45password_45request4Og7u7gVEKuJ8Vda0D41EuiBkq4_4541NUc3Mq3yEsdykMeta || {},
    component: () => import("/build/pages/reset-password-request.vue")
  },
  {
    name: "tests-id-introduction___en___default",
    path: "/tests/:id()/introduction",
    meta: { ...(introduction67FWFc3O6sWjXyYe0lzCYoDiqjYLw88VCS5rgtGYBq8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/introduction.vue")
  },
  {
    name: "tests-id-introduction___en",
    path: "/en/tests/:id()/introduction",
    meta: { ...(introduction67FWFc3O6sWjXyYe0lzCYoDiqjYLw88VCS5rgtGYBq8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/introduction.vue")
  },
  {
    name: "forum-feed-for-you___en___default",
    path: "/forum/feed/for-you",
    meta: { ...(index1E1QvfdoflO4t_45ZxiLphDFHt6H6BoPAEKYveWGOSqk4Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/feed/for-you/index.vue")
  },
  {
    name: "forum-feed-for-you___en",
    path: "/en/forum/feed/for-you",
    meta: { ...(index1E1QvfdoflO4t_45ZxiLphDFHt6H6BoPAEKYveWGOSqk4Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/feed/for-you/index.vue")
  },
  {
    name: "interviews-id-complete___en___default",
    path: "/interviews/:id()/complete",
    meta: { ...(completeTQ3oJMZiUChkZH_9gRkYTEyPbWHtbB4sGGYG25PUU8AMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/complete.vue")
  },
  {
    name: "interviews-id-complete___en",
    path: "/en/interviews/:id()/complete",
    meta: { ...(completeTQ3oJMZiUChkZH_9gRkYTEyPbWHtbB4sGGYG25PUU8AMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/complete.vue")
  },
  {
    name: "profile-saved-jobs___en___default",
    path: "/profile/saved-jobs",
    meta: { ...(indexWBcAqjKijUnXLx2y1GwIq9UJ1cDLkyIiaUx7ITLcAd8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/saved-jobs/index.vue")
  },
  {
    name: "profile-saved-jobs___en",
    path: "/en/profile/saved-jobs",
    meta: { ...(indexWBcAqjKijUnXLx2y1GwIq9UJ1cDLkyIiaUx7ITLcAd8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/saved-jobs/index.vue")
  },
  {
    name: "programmes-register-id___en___default",
    path: "/programmes/register/:id()",
    meta: _91id_93ow_N_45KbBAo3YqoIpLcvTO8xvba5NGkB7ZK5rYdUdZRwMeta || {},
    component: () => import("/build/pages/programmes/register/[id].vue")
  },
  {
    name: "programmes-register-id___en",
    path: "/en/programmes/register/:id()",
    meta: _91id_93ow_N_45KbBAo3YqoIpLcvTO8xvba5NGkB7ZK5rYdUdZRwMeta || {},
    component: () => import("/build/pages/programmes/register/[id].vue")
  },
  {
    name: "skills-tests-id-result___en___default",
    path: "/skills/tests/:id()/result",
    meta: { ...(result7ywexuPOog5Kq9OoOe_45Zc790SrlOyFwoUGjlrd1IdQcMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/tests/[id]/result.vue")
  },
  {
    name: "skills-tests-id-result___en",
    path: "/en/skills/tests/:id()/result",
    meta: { ...(result7ywexuPOog5Kq9OoOe_45Zc790SrlOyFwoUGjlrd1IdQcMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/tests/[id]/result.vue")
  },
  {
    name: "tests-id-error-message___en___default",
    path: "/tests/:id()/error/message",
    meta: { ...(messageVde1e8pt73AxxMt0ohF_8crnIhlvSXqyPMVFRwG5MugMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/error/message.vue")
  },
  {
    name: "tests-id-error-message___en",
    path: "/en/tests/:id()/error/message",
    meta: { ...(messageVde1e8pt73AxxMt0ohF_8crnIhlvSXqyPMVFRwG5MugMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/error/message.vue")
  },
  {
    name: "tests-id-result-review___en___default",
    path: "/tests/:id()/result-review",
    meta: { ...(result_45review1vMXUmWpDZC_45DuqgCZVP32ZuRSaqNj5BpNYTuBpsko8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/result-review.vue")
  },
  {
    name: "tests-id-result-review___en",
    path: "/en/tests/:id()/result-review",
    meta: { ...(result_45review1vMXUmWpDZC_45DuqgCZVP32ZuRSaqNj5BpNYTuBpsko8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/result-review.vue")
  },
  {
    name: "courses-learn-course-id___en___default",
    path: "/courses/learn/course/:id()",
    meta: { ...(_91id_93gMm37bBythg_45lpmT_45PJVHQXcxBmqrxMKaQDHLoqWYPkMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/learn/course/[id].vue")
  },
  {
    name: "courses-learn-course-id___en",
    path: "/en/courses/learn/course/:id()",
    meta: { ...(_91id_93gMm37bBythg_45lpmT_45PJVHQXcxBmqrxMKaQDHLoqWYPkMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/learn/course/[id].vue")
  },
  {
    name: "forum-tag-following___en___default",
    path: "/forum/tag/following",
    meta: { ...(indexg5LC_KalBLFR3mLJ_45vDe0Nez4bDkJeAXbtxTysjqNnsMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/tag/following/index.vue")
  },
  {
    name: "forum-tag-following___en",
    path: "/en/forum/tag/following",
    meta: { ...(indexg5LC_KalBLFR3mLJ_45vDe0Nez4bDkJeAXbtxTysjqNnsMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/tag/following/index.vue")
  },
  {
    name: "interviews-id-disclaimer___en___default",
    path: "/interviews/:id()/disclaimer",
    meta: {"middleware":"authcheck"},
    component: () => import("/build/pages/interviews/[id]/disclaimer.vue")
  },
  {
    name: "interviews-id-disclaimer___en",
    path: "/en/interviews/:id()/disclaimer",
    meta: {"middleware":"authcheck"},
    component: () => import("/build/pages/interviews/[id]/disclaimer.vue")
  },
  {
    name: "interviews-id-error-next___en___default",
    path: "/interviews/:id()/error/next",
    meta: { ...(next3Wonm1GQuYY_brj5SI_ZDUckwhu84FCiyA6Vx8KFs_45sMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/error/next.vue")
  },
  {
    name: "interviews-id-error-next___en",
    path: "/en/interviews/:id()/error/next",
    meta: { ...(next3Wonm1GQuYY_brj5SI_ZDUckwhu84FCiyA6Vx8KFs_45sMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/error/next.vue")
  },
  {
    name: "profile-applied-jobs___en___default",
    path: "/profile/applied-jobs",
    meta: { ...(indexjRSemUdeVUwYu3EtYj5SubleP5SmYa0HNej9zmFnEPAMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/applied-jobs/index.vue")
  },
  {
    name: "profile-applied-jobs___en",
    path: "/en/profile/applied-jobs",
    meta: { ...(indexjRSemUdeVUwYu3EtYj5SubleP5SmYa0HNej9zmFnEPAMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/profile/applied-jobs/index.vue")
  },
  {
    name: "tests-id-browser-proctor___en___default",
    path: "/tests/:id()/browser-proctor",
    meta: {"middleware":"authcheck"},
    component: () => import("/build/pages/tests/[id]/browser-proctor.vue")
  },
  {
    name: "tests-id-browser-proctor___en",
    path: "/en/tests/:id()/browser-proctor",
    meta: {"middleware":"authcheck"},
    component: () => import("/build/pages/tests/[id]/browser-proctor.vue")
  },
  {
    name: "tests-id-technical-check___en___default",
    path: "/tests/:id()/technical-check",
    meta: { ...(technical_45checkMDMXm2wEoqw9aLANJv6TdpH4ItmBdtUDkx9iN4rlhGIMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/technical-check.vue")
  },
  {
    name: "tests-id-technical-check___en",
    path: "/en/tests/:id()/technical-check",
    meta: { ...(technical_45checkMDMXm2wEoqw9aLANJv6TdpH4ItmBdtUDkx9iN4rlhGIMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/tests/[id]/technical-check.vue")
  },
  {
    name: "forum-class-forum-add___en___default",
    path: "/forum/class-forum/add",
    meta: { ...(indexjv9DvvxB96OJDXwXduNRlv0ctPsl_45RMBPuhaulFIH7YMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/add/index.vue")
  },
  {
    name: "forum-class-forum-add___en",
    path: "/en/forum/class-forum/add",
    meta: { ...(indexjv9DvvxB96OJDXwXduNRlv0ctPsl_45RMBPuhaulFIH7YMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/add/index.vue")
  },
  {
    name: "forum-tag-browse-category___en___default",
    path: "/forum/tag/browse/:category()",
    meta: _91category_93oYriR2eO3oKM_45gSDWqFqZbwAOIzRVrs4ZHOK_45Y5GujYMeta || {},
    component: () => import("/build/pages/forum/tag/browse/[category].vue")
  },
  {
    name: "forum-tag-browse-category___en",
    path: "/en/forum/tag/browse/:category()",
    meta: _91category_93oYriR2eO3oKM_45gSDWqFqZbwAOIzRVrs4ZHOK_45Y5GujYMeta || {},
    component: () => import("/build/pages/forum/tag/browse/[category].vue")
  },
  {
    name: "forum-history-comments___en___default",
    path: "/forum/history/comments",
    meta: { ...(index0iCbak8HcvnQd5_nTrwwOXeAjcLf6DGo0Exf4xtmNFsMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/history/comments/index.vue")
  },
  {
    name: "forum-history-comments___en",
    path: "/en/forum/history/comments",
    meta: { ...(index0iCbak8HcvnQd5_nTrwwOXeAjcLf6DGo0Exf4xtmNFsMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/history/comments/index.vue")
  },
  {
    name: "interviews-id-introduction___en___default",
    path: "/interviews/:id()/introduction",
    meta: { ...(introduction2uFHAdo_45ouq7uFfi1Pn2da_45d1C1_bJOGbbX__452WN3D8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/introduction.vue")
  },
  {
    name: "interviews-id-introduction___en",
    path: "/en/interviews/:id()/introduction",
    meta: { ...(introduction2uFHAdo_45ouq7uFfi1Pn2da_45d1C1_bJOGbbX__452WN3D8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/introduction.vue")
  },
  {
    name: "forum-bookmark-comments___en___default",
    path: "/forum/bookmark/comments",
    meta: { ...(indexNwS8hhMS_z4oLOlJlEqQr2kJGTKKgozZObHVxkkfo0UMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/bookmark/comments/index.vue")
  },
  {
    name: "forum-bookmark-comments___en",
    path: "/en/forum/bookmark/comments",
    meta: { ...(indexNwS8hhMS_z4oLOlJlEqQr2kJGTKKgozZObHVxkkfo0UMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/bookmark/comments/index.vue")
  },
  {
    name: "forum-class-forum-edit-slug___en___default",
    path: "/forum/class-forum/edit/:slug()",
    meta: { ...(_91slug_93NKOL3wdfnzyhbFVxBj3ZmBi2ZDZUDt5MIgc1WWmkIwkMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/edit/[slug].vue")
  },
  {
    name: "forum-class-forum-edit-slug___en",
    path: "/en/forum/class-forum/edit/:slug()",
    meta: { ...(_91slug_93NKOL3wdfnzyhbFVxBj3ZmBi2ZDZUDt5MIgc1WWmkIwkMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/edit/[slug].vue")
  },
  {
    name: "interviews-id-error-message___en___default",
    path: "/interviews/:id()/error/message",
    meta: { ...(messageVB_Kl69akAME3ChXiRk_45NJPCy1Nj0tBQImK0OJbgIQEMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/error/message.vue")
  },
  {
    name: "interviews-id-error-message___en",
    path: "/en/interviews/:id()/error/message",
    meta: { ...(messageVB_Kl69akAME3ChXiRk_45NJPCy1Nj0tBQImK0OJbgIQEMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/error/message.vue")
  },
  {
    name: "courses-learn-certificate-id___en___default",
    path: "/courses/learn/certificate/:id()",
    meta: { ...(_91id_93e3Kl4UG2mM1ZdxT_45IQGjnKSMOq3O_45FfhXeYslK3jzsYMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/learn/certificate/[id].vue")
  },
  {
    name: "courses-learn-certificate-id___en",
    path: "/en/courses/learn/certificate/:id()",
    meta: { ...(_91id_93e3Kl4UG2mM1ZdxT_45IQGjnKSMOq3O_45FfhXeYslK3jzsYMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/courses/learn/certificate/[id].vue")
  },
  {
    name: "forum-class-forum-slug___en___default",
    path: "/forum/class-forum/:slug()",
    meta: { ...(indexghb_45YAzeGoNVdBy8j8R05_g9k5Z9yQcT7cFTKz0oO4cMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/[slug]/index.vue")
  },
  {
    name: "forum-class-forum-slug___en",
    path: "/en/forum/class-forum/:slug()",
    meta: { ...(indexghb_45YAzeGoNVdBy8j8R05_g9k5Z9yQcT7cFTKz0oO4cMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/[slug]/index.vue")
  },
  {
    name: "skills-admin-assessments___en___default",
    path: "/skills/admin/assessments",
    meta: { ...(indexJt_SdUHEEKpR2P0s0awKiW1rjaLXnQJ1iIlxB5qr138Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/index.vue")
  },
  {
    name: "skills-admin-assessments___en",
    path: "/en/skills/admin/assessments",
    meta: { ...(indexJt_SdUHEEKpR2P0s0awKiW1rjaLXnQJ1iIlxB5qr138Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/index.vue")
  },
  {
    name: "skills-admin-tests-id-result___en___default",
    path: "/skills/admin/tests/:id()/result",
    meta: { ...(resultQBooMIPwJVlaNhwcUIfIHN5EJyMOJKk3RTyYQ6AUIDwMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/tests/[id]/result.vue")
  },
  {
    name: "skills-admin-tests-id-result___en",
    path: "/en/skills/admin/tests/:id()/result",
    meta: { ...(resultQBooMIPwJVlaNhwcUIfIHN5EJyMOJKk3RTyYQ6AUIDwMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/tests/[id]/result.vue")
  },
  {
    name: "interviews-id-technical-check___en___default",
    path: "/interviews/:id()/technical-check",
    meta: { ...(technical_45check_VRf0pAnSO5hWqMDX1Bav01xXSITEjDcPJQZHyRokYMMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/technical-check.vue")
  },
  {
    name: "interviews-id-technical-check___en",
    path: "/en/interviews/:id()/technical-check",
    meta: { ...(technical_45check_VRf0pAnSO5hWqMDX1Bav01xXSITEjDcPJQZHyRokYMMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/interviews/[id]/technical-check.vue")
  },
  {
    name: "skills-interviews-id-feedback___en___default",
    path: "/skills/interviews/:id()/feedback",
    meta: { ...(feedbackxhhjlxJvRtjKgNnw6BAqIHJ3RVX1hbZDe1QDNJR3oHsMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/interviews/[id]/feedback.vue")
  },
  {
    name: "skills-interviews-id-feedback___en",
    path: "/en/skills/interviews/:id()/feedback",
    meta: { ...(feedbackxhhjlxJvRtjKgNnw6BAqIHJ3RVX1hbZDe1QDNJR3oHsMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/interviews/[id]/feedback.vue")
  },
  {
    name: "skills-interviews-id-recording___en___default",
    path: "/skills/interviews/:id()/recording",
    meta: { ...(recordingym43BRv3L_450iCynxTWSEtcgztCL8ZinMm0XAAUP99TUMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/interviews/[id]/recording.vue")
  },
  {
    name: "skills-interviews-id-recording___en",
    path: "/en/skills/interviews/:id()/recording",
    meta: { ...(recordingym43BRv3L_450iCynxTWSEtcgztCL8ZinMm0XAAUP99TUMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/interviews/[id]/recording.vue")
  },
  {
    name: "forum-history-announcements___en___default",
    path: "/forum/history/announcements",
    meta: { ...(indexbi3_fzOdSZ0pyhkGrVAOAaHHbevBASWO9jnXyD5MCSQMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/history/announcements/index.vue")
  },
  {
    name: "forum-history-announcements___en",
    path: "/en/forum/history/announcements",
    meta: { ...(indexbi3_fzOdSZ0pyhkGrVAOAaHHbevBASWO9jnXyD5MCSQMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/history/announcements/index.vue")
  },
  {
    name: "skills-admin-interviews-id-error___en___default",
    path: "/skills/admin/interviews/:id()/error",
    meta: { ...(error__45sVYkr_9lvMhzDSIGXPDoH3aqxfXIMoDCDOyrmzt1YMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/interviews/[id]/error.vue")
  },
  {
    name: "skills-admin-interviews-id-error___en",
    path: "/en/skills/admin/interviews/:id()/error",
    meta: { ...(error__45sVYkr_9lvMhzDSIGXPDoH3aqxfXIMoDCDOyrmzt1YMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/interviews/[id]/error.vue")
  },
  {
    name: "forum-post-edit-comment-commentId___en___default",
    path: "/forum/post/edit/comment/:commentId()",
    meta: { ...(_91commentId_93qZbYZMLgZL2pOxle9Z7Avts7lzivPE3oKa_45il3x5YPgMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/post/edit/comment/[commentId].vue")
  },
  {
    name: "forum-post-edit-comment-commentId___en",
    path: "/en/forum/post/edit/comment/:commentId()",
    meta: { ...(_91commentId_93qZbYZMLgZL2pOxle9Z7Avts7lzivPE3oKa_45il3x5YPgMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/post/edit/comment/[commentId].vue")
  },
  {
    name: "forum-class-forum-slug-posts___en___default",
    path: "/forum/class-forum/:slug()/posts",
    meta: indexKzsBeof2ObI8JloDHFssGdqkU4Hks_45wdNzpJHoe6MfsMeta || {},
    component: () => import("/build/pages/forum/class-forum/[slug]/posts/index.vue")
  },
  {
    name: "forum-class-forum-slug-posts___en",
    path: "/en/forum/class-forum/:slug()/posts",
    meta: indexKzsBeof2ObI8JloDHFssGdqkU4Hks_45wdNzpJHoe6MfsMeta || {},
    component: () => import("/build/pages/forum/class-forum/[slug]/posts/index.vue")
  },
  {
    name: "skills-admin-assessments-create-test___en___default",
    path: "/skills/admin/assessments/create/test",
    meta: { ...(testeAVDgWpK2Ymeq3MrlENVd05_KNiH6bQD3x12hnGMHx0Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/create/test.vue")
  },
  {
    name: "skills-admin-assessments-create-test___en",
    path: "/en/skills/admin/assessments/create/test",
    meta: { ...(testeAVDgWpK2Ymeq3MrlENVd05_KNiH6bQD3x12hnGMHx0Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/create/test.vue")
  },
  {
    name: "forum-class-forum-slug-pinned___en___default",
    path: "/forum/class-forum/:slug()/pinned",
    meta: indexRsSZ7KfvyT044vXhXE4H3ntR_4505NdX5NBhWZRhJqagEMeta || {},
    component: () => import("/build/pages/forum/class-forum/[slug]/pinned/index.vue")
  },
  {
    name: "forum-class-forum-slug-pinned___en",
    path: "/en/forum/class-forum/:slug()/pinned",
    meta: indexRsSZ7KfvyT044vXhXE4H3ntR_4505NdX5NBhWZRhJqagEMeta || {},
    component: () => import("/build/pages/forum/class-forum/[slug]/pinned/index.vue")
  },
  {
    name: "skills-admin-interviews-id-feedback___en___default",
    path: "/skills/admin/interviews/:id()/feedback",
    meta: { ...(feedbackYhZJOPqdkEKCERfbRftUh5lcPu6qJaGVmvZVkKPqKngMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/interviews/[id]/feedback.vue")
  },
  {
    name: "skills-admin-interviews-id-feedback___en",
    path: "/en/skills/admin/interviews/:id()/feedback",
    meta: { ...(feedbackYhZJOPqdkEKCERfbRftUh5lcPu6qJaGVmvZVkKPqKngMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/interviews/[id]/feedback.vue")
  },
  {
    name: "forum-class-forum-slug-support___en___default",
    path: "/forum/class-forum/:slug()/support",
    meta: indexUxRxmNJ4X6dEP_451PIfjeOSIOgUvrUXH_45h62Kdss9wWcMeta || {},
    component: () => import("/build/pages/forum/class-forum/[slug]/support/index.vue")
  },
  {
    name: "forum-class-forum-slug-support___en",
    path: "/en/forum/class-forum/:slug()/support",
    meta: indexUxRxmNJ4X6dEP_451PIfjeOSIOgUvrUXH_45h62Kdss9wWcMeta || {},
    component: () => import("/build/pages/forum/class-forum/[slug]/support/index.vue")
  },
  {
    name: "forum-class-forum-my-class-forum___en___default",
    path: "/forum/class-forum/my-class-forum",
    meta: { ...(index_Ibb_Xb0QHe_45s156w8E7X_MnO5EN1hPvWrTcWJCKYBoMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/my-class-forum/index.vue")
  },
  {
    name: "forum-class-forum-my-class-forum___en",
    path: "/en/forum/class-forum/my-class-forum",
    meta: { ...(index_Ibb_Xb0QHe_45s156w8E7X_MnO5EN1hPvWrTcWJCKYBoMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/my-class-forum/index.vue")
  },
  {
    name: "programmes-student-my-programmes___en___default",
    path: "/programmes/student/my-programmes",
    meta: indexWbMmzi_45l4n8KMUdnhF37LmyKA0cgWTqUTsSMNC_45bX_45MMeta || {},
    component: () => import("/build/pages/programmes/student/my-programmes/index.vue")
  },
  {
    name: "programmes-student-my-programmes___en",
    path: "/en/programmes/student/my-programmes",
    meta: indexWbMmzi_45l4n8KMUdnhF37LmyKA0cgWTqUTsSMNC_45bX_45MMeta || {},
    component: () => import("/build/pages/programmes/student/my-programmes/index.vue")
  },
  {
    name: "forum-class-forum-slug-students___en___default",
    path: "/forum/class-forum/:slug()/students",
    meta: { ...(indexHEkdz7UivuMUOdboBG9xt87yfww_451QkjP8DSub7IVjgMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/[slug]/students/index.vue")
  },
  {
    name: "forum-class-forum-slug-students___en",
    path: "/en/forum/class-forum/:slug()/students",
    meta: { ...(indexHEkdz7UivuMUOdboBG9xt87yfww_451QkjP8DSub7IVjgMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/[slug]/students/index.vue")
  },
  {
    name: "forum-class-forum-add-announcement___en___default",
    path: "/forum/class-forum/add-announcement",
    meta: { ...(index_45anOaU5QNO6FUAIkmKktJr8WxxrGj3XQcgX17mnuxFkMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/add-announcement/index.vue")
  },
  {
    name: "forum-class-forum-add-announcement___en",
    path: "/en/forum/class-forum/add-announcement",
    meta: { ...(index_45anOaU5QNO6FUAIkmKktJr8WxxrGj3XQcgX17mnuxFkMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/add-announcement/index.vue")
  },
  {
    name: "forum-class-forum-edit-announcement-id___en___default",
    path: "/forum/class-forum/edit-announcement/:id()",
    meta: _91id_93pwmlqb7xxCh3PqaxH7rIUYsiyqad__nkIX3XlPPPtOwMeta || {},
    component: () => import("/build/pages/forum/class-forum/edit-announcement/[id].vue")
  },
  {
    name: "forum-class-forum-edit-announcement-id___en",
    path: "/en/forum/class-forum/edit-announcement/:id()",
    meta: _91id_93pwmlqb7xxCh3PqaxH7rIUYsiyqad__nkIX3XlPPPtOwMeta || {},
    component: () => import("/build/pages/forum/class-forum/edit-announcement/[id].vue")
  },
  {
    name: "programmes-student-find-programmes___en___default",
    path: "/programmes/student/find-programmes",
    meta: index_Y3RVhXJRhT__KCD0jnCfbUdAsJH3hsREfXTkaKscRsMeta || {},
    component: () => import("/build/pages/programmes/student/find-programmes/index.vue")
  },
  {
    name: "programmes-student-find-programmes___en",
    path: "/en/programmes/student/find-programmes",
    meta: index_Y3RVhXJRhT__KCD0jnCfbUdAsJH3hsREfXTkaKscRsMeta || {},
    component: () => import("/build/pages/programmes/student/find-programmes/index.vue")
  },
  {
    name: "skills-admin-assessments-tests-id-edit___en___default",
    path: "/skills/admin/assessments/tests/:id()/edit",
    meta: { ...(edit8nu_NHQMmK7zIRkNAzKFt5scgqox1GewL3_45mPUlMJZUMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/tests/[id]/edit.vue")
  },
  {
    name: "skills-admin-assessments-tests-id-edit___en",
    path: "/en/skills/admin/assessments/tests/:id()/edit",
    meta: { ...(edit8nu_NHQMmK7zIRkNAzKFt5scgqox1GewL3_45mPUlMJZUMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/tests/[id]/edit.vue")
  },
  {
    name: "forum-class-forum-slug-moderators___en___default",
    path: "/forum/class-forum/:slug()/moderators",
    meta: { ...(indexmq3tv2NSDixzNIRSvYMyvBxP_45_fBb0l7Gju2BEgroMIMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/[slug]/moderators/index.vue")
  },
  {
    name: "forum-class-forum-slug-moderators___en",
    path: "/en/forum/class-forum/:slug()/moderators",
    meta: { ...(indexmq3tv2NSDixzNIRSvYMyvBxP_45_fBb0l7Gju2BEgroMIMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/[slug]/moderators/index.vue")
  },
  {
    name: "forum-class-forum-add-id-students___en___default",
    path: "/forum/class-forum/add/:id()/students",
    meta: { ...(indexR3Hd18CUFanBJTLB_45UW2ytkmXktTR1nJJqPzUKoNEA8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/add/[id]/students/index.vue")
  },
  {
    name: "forum-class-forum-add-id-students___en",
    path: "/en/forum/class-forum/add/:id()/students",
    meta: { ...(indexR3Hd18CUFanBJTLB_45UW2ytkmXktTR1nJJqPzUKoNEA8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/add/[id]/students/index.vue")
  },
  {
    name: "skills-admin-assessments-create-interview___en___default",
    path: "/skills/admin/assessments/create/interview",
    meta: { ...(interviewZi8DouAcOD2fPL2_45Z3KyKupjmglfZwTWulf_PWb0r8wMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/create/interview.vue")
  },
  {
    name: "skills-admin-assessments-create-interview___en",
    path: "/en/skills/admin/assessments/create/interview",
    meta: { ...(interviewZi8DouAcOD2fPL2_45Z3KyKupjmglfZwTWulf_PWb0r8wMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/create/interview.vue")
  },
  {
    name: "skills-admin-assessments-tests-id-invite___en___default",
    path: "/skills/admin/assessments/tests/:id()/invite",
    meta: { ...(inviteEGVG4zDaVWASd3XgOlUy43aNN_aay0o5TF6aKx0T00gMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/tests/[id]/invite.vue")
  },
  {
    name: "skills-admin-assessments-tests-id-invite___en",
    path: "/en/skills/admin/assessments/tests/:id()/invite",
    meta: { ...(inviteEGVG4zDaVWASd3XgOlUy43aNN_aay0o5TF6aKx0T00gMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/tests/[id]/invite.vue")
  },
  {
    name: "forum-class-forum-add-id-moderators___en___default",
    path: "/forum/class-forum/add/:id()/moderators",
    meta: { ...(index5gsp_Ts805MUv6ScKaV8ADrylmW4NKFPJP9JqPBMtAgMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/add/[id]/moderators/index.vue")
  },
  {
    name: "forum-class-forum-add-id-moderators___en",
    path: "/en/forum/class-forum/add/:id()/moderators",
    meta: { ...(index5gsp_Ts805MUv6ScKaV8ADrylmW4NKFPJP9JqPBMtAgMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/add/[id]/moderators/index.vue")
  },
  {
    name: "skills-admin-assessments-tests-id-results___en___default",
    path: "/skills/admin/assessments/tests/:id()/results",
    meta: { ...(resultsKfS9QvmPmnfur71VVc9bOOocu4vJtSWUJkXHSQuj1bwMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/tests/[id]/results.vue")
  },
  {
    name: "skills-admin-assessments-tests-id-results___en",
    path: "/en/skills/admin/assessments/tests/:id()/results",
    meta: { ...(resultsKfS9QvmPmnfur71VVc9bOOocu4vJtSWUJkXHSQuj1bwMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/tests/[id]/results.vue")
  },
  {
    name: "forum-class-forum-slug-announcements___en___default",
    path: "/forum/class-forum/:slug()/announcements",
    meta: { ...(indexfAHvYdXtChnl3pxNqQvnBqai3Bj0g01OPsifDq456tEMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/[slug]/announcements/index.vue")
  },
  {
    name: "forum-class-forum-slug-announcements___en",
    path: "/en/forum/class-forum/:slug()/announcements",
    meta: { ...(indexfAHvYdXtChnl3pxNqQvnBqai3Bj0g01OPsifDq456tEMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/forum/class-forum/[slug]/announcements/index.vue")
  },
  {
    name: "skills-admin-assessments-interviews-id-edit___en___default",
    path: "/skills/admin/assessments/interviews/:id()/edit",
    meta: { ...(editRoawuu5oAiSYiVaw5bCdhaMIZrSRJLlvf2wWg4AXGx4Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/interviews/[id]/edit.vue")
  },
  {
    name: "skills-admin-assessments-interviews-id-edit___en",
    path: "/en/skills/admin/assessments/interviews/:id()/edit",
    meta: { ...(editRoawuu5oAiSYiVaw5bCdhaMIZrSRJLlvf2wWg4AXGx4Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/interviews/[id]/edit.vue")
  },
  {
    name: "skills-admin-assessments-tests-id-invite-one___en___default",
    path: "/skills/admin/assessments/tests/:id()/invite-one",
    meta: { ...(invite_45one6WuQUyHoqBBNvC5ugH5dwK53sRbBeVT83Lnu_45yQMfr4Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/tests/[id]/invite-one.vue")
  },
  {
    name: "skills-admin-assessments-tests-id-invite-one___en",
    path: "/en/skills/admin/assessments/tests/:id()/invite-one",
    meta: { ...(invite_45one6WuQUyHoqBBNvC5ugH5dwK53sRbBeVT83Lnu_45yQMfr4Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/tests/[id]/invite-one.vue")
  },
  {
    name: "classroom-learn-courseName-contentType-id___en___default",
    path: "/classroom/learn/:courseName()/:contentType()/:id()",
    meta: _91id_93Uu0pQ7yz01NEIlWFxypTRnxc3rlHADWyTLKVWlJpIbsMeta || {},
    component: () => import("/build/pages/classroom/learn/[courseName]/[contentType]/[id].vue")
  },
  {
    name: "classroom-learn-courseName-contentType-id___en",
    path: "/en/classroom/learn/:courseName()/:contentType()/:id()",
    meta: _91id_93Uu0pQ7yz01NEIlWFxypTRnxc3rlHADWyTLKVWlJpIbsMeta || {},
    component: () => import("/build/pages/classroom/learn/[courseName]/[contentType]/[id].vue")
  },
  {
    name: "skills-admin-assessments-interviews-id-invite___en___default",
    path: "/skills/admin/assessments/interviews/:id()/invite",
    meta: { ...(invitebktcILa5szvD0H8zw7dAgQgkpzLSGgVoZwVnlQ_uXmAMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/interviews/[id]/invite.vue")
  },
  {
    name: "skills-admin-assessments-interviews-id-invite___en",
    path: "/en/skills/admin/assessments/interviews/:id()/invite",
    meta: { ...(invitebktcILa5szvD0H8zw7dAgQgkpzLSGgVoZwVnlQ_uXmAMeta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/interviews/[id]/invite.vue")
  },
  {
    name: "skills-admin-assessments-interviews-id-results___en___default",
    path: "/skills/admin/assessments/interviews/:id()/results",
    meta: { ...(results8mbySP59w34iROG8zBJN06Br8z3EVzqM3mlaKSxvYP8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/interviews/[id]/results.vue")
  },
  {
    name: "skills-admin-assessments-interviews-id-results___en",
    path: "/en/skills/admin/assessments/interviews/:id()/results",
    meta: { ...(results8mbySP59w34iROG8zBJN06Br8z3EVzqM3mlaKSxvYP8Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/interviews/[id]/results.vue")
  },
  {
    name: "skills-admin-assessments-interviews-id-invite-one___en___default",
    path: "/skills/admin/assessments/interviews/:id()/invite-one",
    meta: { ...(invite_45one_QpIx1oMx70tzhIiCseIy6T7SlaK2t4TLyHjwUVrv_450Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/interviews/[id]/invite-one.vue")
  },
  {
    name: "skills-admin-assessments-interviews-id-invite-one___en",
    path: "/en/skills/admin/assessments/interviews/:id()/invite-one",
    meta: { ...(invite_45one_QpIx1oMx70tzhIiCseIy6T7SlaK2t4TLyHjwUVrv_450Meta || {}), ...{"middleware":"authcheck"} },
    component: () => import("/build/pages/skills/admin/assessments/interviews/[id]/invite-one.vue")
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/be-instructor",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/be-instructor",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/team",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/team",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/m1-modules/javascript",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/m1-modules/javascript",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/m1-modules/python",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/m1-modules/python",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/m1-modules/sql",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/m1-modules/sql",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/m1-modules/blockchain",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/m1-modules/blockchain",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/m1-modules/fintech",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/m1-modules/fintech",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/foundation-certificates/data-analytics",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/foundation-certificates/data-analytics",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/foundation-certificates/digital-marketing",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/foundation-certificates/digital-marketing",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/foundation-certificates/software-engineering",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/foundation-certificates/software-engineering",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/foundation-certificates/ux-design",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/foundation-certificates/ux-design",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/foundation-certificates/technology-management",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/foundation-certificates/technology-management",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/certified-associate/software-engineering",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/certified-associate/software-engineering",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/certified-associate/data-analytics",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/certified-associate/data-analytics",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/certified-associate/back-end-development",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/certified-associate/back-end-development",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/certified-associate/front-end-development",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/certified-associate/front-end-development",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/certified-associate/business-analytics",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/certified-associate/business-analytics",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/certified-associate/pwc-certified-associate-in-penetration-testing",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/certified-associate/pwc-certified-associate-in-penetration-testing",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/pay-to-enroll",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/pay-to-enroll",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/apply-to-enroll",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/apply-to-enroll",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/classroom",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  },
  {
    name: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8Meta?.name,
    path: "/en/classroom",
    component: component_45stubOAuPy6EZIn0BrEQtH4zHDmYCie3PWRZFboIo4ghk3j8
  }
]